import kiwApi from '@/api/v1/kiw';

export default {
  namespaced: true,

  state: {
    kiwList: [],
  },

  mutations: {
    SET_KIW(state, items) {
      state.kiwList = items;
    },

    REMOVE_KIW(state) {
      state.kiwList = [];
    },
  },

  actions: {
    fetchKIW({ commit, rootState }) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });

      const { selectedFilters } = rootState.filters;
      const { itemsPerPage, pagination } = rootState.pagination;

      const params = {
        page: pagination.page,
        itemsPerPage,
        filters: selectedFilters,
      };

      kiwApi.index(params)
        .then((resp) => {
          commit('pagination/SET_PAGINATION', resp.data.pagination, { root: true });
          commit('SET_KIW', resp.data.collection);
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },

    deleteSingleKiw({ commit, dispatch }, id) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });

      return kiwApi.delete(id)
        .then(() => {
          dispatch('snackbar/showSnackbar', {
            message: ['Wniosek został usunięty'],
            type: 'success',
          }, { root: true });
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },

    deleteMultipleKIW({ commit, dispatch }, requestIds) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });

      return kiwApi.bulkDelete(requestIds)
        .then(() => {
          dispatch('fetchKIW');
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },
    resetKIW({ commit, dispatch }) {
      commit('REMOVE_KIW');
      dispatch('filters/clearFilters', null, { root: true });
      dispatch('pagination/resetPagination', null, { root: true });
    },
  },
};
